<template>
  <div>
     <b-modal id="modalEditAccountingPeriod" ref="modalEditAccountingPeriod" :title="$t('Accounting period detail')" hide-footer @shown="shown">
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.id > 0">
          <b-form-input type="text" disabled v-model="editItem.id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Start time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <flat-picker
            :isDisabled="editItem.id > 0"
            @onDateChanged="(unixDate) => {editItem.start_time = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(editItem.start_time ? editItem.start_time : new Date()/1000 ).toDate())}"
          />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('End time')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.id > 0">
          <flat-picker
            @onDateChanged="(unixDate) => {editItem.end = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(editItem.end ? editItem.end : new Date()/1000 ).toDate())}"
          />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Period type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="typeAccountingPeriods" v-model="editItem.periodic_type" :disabled="editItem.id > 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Report period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="listOfMonthly" v-model="editItem.invoice_month" :disabled="editItem.periodic_type !== 3"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Custom duration(sec)')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" :disabled="editItem.id > 0 || editItem.periodic_type !== 1048576" v-model="editItem.custom_duration"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Set number of charges')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-checkbox :disabled="editItem.id > 0" v-model="numOfCharges"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Charges per week')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" :disabled="editItem.id > 0 || !numOfCharges" v-model="editItem.charge_interval"/>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditAccountingPeriod')" />
      </div>
     </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      numOfCharges: false,
      typeAccountingPeriods: [
        { text: this.$i18n.t('Daily'), value: 1 },
        { text: this.$i18n.t('Weekly'), value: 2 },
        { text: this.$i18n.t('Monthly'), value: 3 },
        { text: this.$i18n.t('Quarterly'), value: 4 },
        { text: this.$i18n.t('Annual'), value: 5 },
        { text: this.$i18n.t('CustomDuration'), value: 1048576 }
      ],
      listOfMonthly: [
        { text: this.$i18n.t('Not select'), value: 0 },
        { text: this.$i18n.t('January(1)'), value: 1 },
        { text: this.$i18n.t('February(2)'), value: 2 },
        { text: this.$i18n.t('March(3)'), value: 3 },
        { text: this.$i18n.t('April(4)'), value: 4 },
        { text: this.$i18n.t('May(5)'), value: 5 },
        { text: this.$i18n.t('June(6)'), value: 6 },
        { text: this.$i18n.t('July(7)'), value: 7 },
        { text: this.$i18n.t('August(8)'), value: 8 },
        { text: this.$i18n.t('September(9)'), value: 9 },
        { text: this.$i18n.t('October(10)'), value: 10 },
        { text: this.$i18n.t('November(11)'), value: 11 },
        { text: this.$i18n.t('December(12)'), value: 12 }
      ]
    }
  },
  methods: {
    save () {
      let newAP = {
        id: 0,
        start_time: 0,
        expire_time: 0,
        acc_period_type: 0,
        custom_duration: 0,
        charge_interval: 0,
        invoice_month: 0,
        name: ''
      }
      newAP.name = this.editItem.name
      newAP.id = this.editItem.id
      newAP.acc_period_type = this.editItem.periodic_type
      newAP.charge_interval = Number(this.editItem.charge_interval)
      newAP.custom_duration = Number(this.editItem.custom_duration)
      if (this.editItem.start_time < Number(new Date()) / 1000) {
        this.editItem.start_time = this.$root.getMomentWithTZDelta(moment().unix()).unix()
      }
      newAP.start_time = this.editItem.start_time
      newAP.invoice_month = this.editItem.invoice_month
      if (this.editItem.periodic_type !== 1048576) {
        newAP.custom_duration = 0
      }
      if (this.editItem.periodic_type !== 3) {
        newAP.invoice_month = 0
      }
      if (!this.numOfCharges) {
        newAP.charge_interval = 0
      }
      if (this.editItem.id > 0) {
        newAP.expire_time = this.editItem.end
      } else {
        delete newAP.expire_time
      }
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_ACCOUNTING_PERIODS', newAP)
        : this.$store.dispatch('Tariffing/CREATE_ACCOUNTING_PERIODS', newAP)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_ACCOUNTING_PERIODS')
          this.$refs.modalEditAccountingPeriod.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id > 0) {
        if (this.editItem.charge_interval) {
          this.numOfCharges = true
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/additional/accountingPeriods/editModal.vue